import React, { Component } from "react"
import PropTypes from "prop-types"
import {
  Button,
  ButtonToolbar,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  HelpBlock,
  Alert,
} from "react-bootstrap"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import ProcessesStatus from "../fragments/ProcessesStatus"
import moment from "moment"
import {
  DATE_FORMAT_STR,
  formatCurrency,
  validateDateState,
  validateTextState,
  VALIDATION_TYPE
} from "../../lib/utils"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"
import FormControlInlineSelect from "../fragments/FormControl.Inline.Select"
import FormControlInlineDate from "../fragments/FormControl.Inline.Date"
import FormControlInlineInput from "../fragments/FormControl.Inline.Input"

class RepaymentForm extends Component {

  constructor(props) {

    super(props)
    const { loan } = this.props
    this.loanDate = moment(loan.disburseDate).format(DATE_FORMAT_STR)

    this.state = {
      transactionDate: moment().format(DATE_FORMAT_STR),
      transactionAmount: '',
      paymentType: 'CASH',
      accountToDebit: '',
      note: '',
      error: null,
      transactionAmountValidate: VALIDATION_TYPE.NULL,
      paymentTypeValidate: VALIDATION_TYPE.SUCCESS,
      accountToDebitValidationState: VALIDATION_TYPE.NULL,
      noteValidate: VALIDATION_TYPE.NULL,
    }
  }

  getCurrentBalance = () => {

    const { loanDetails } = this.props,
    loanSummary = loanDetails && loanDetails.summary
    return loanSummary ? loanSummary.totalOutstanding : ''
  }

  /**
   * The note must be at least 3 chars
   */
  getNoteValidationState = note => {
    const length = note ? note.length : 0
    return length > 2 ? VALIDATION_TYPE.SUCCESS : length > 0 
      ? VALIDATION_TYPE.ERROR : VALIDATION_TYPE.NULL
  }

  getAmountValidationState = transactionAmount => {

    const trAmount = Number(transactionAmount),
    totalAmount = Number(this.getCurrentBalance())

    if(trAmount > 0 && trAmount <= totalAmount) return VALIDATION_TYPE.SUCCESS
    if(trAmount <= 0 || isNaN(trAmount) || trAmount > totalAmount) return VALIDATION_TYPE.ERROR
    return VALIDATION_TYPE.NULL
  }

  getPaymentTypeValidationState = paymentType => paymentType === 'CASH'
    ? VALIDATION_TYPE.SUCCESS : VALIDATION_TYPE.ERROR

  transactionDateChanged = transactionDate => this.setState({
    transactionDate,
    error: null,
  })

  transactionAmountChanged = transactionAmount => this.setState({
    transactionAmount,
    transactionAmountValidate: this.getAmountValidationState(transactionAmount),
    error: null,
  })

  paymentTypeChanged = paymentType => this.setState({
    paymentType,
    paymentTypeValidate: this.getPaymentTypeValidationState(paymentType),
    error: null,
  })

  accountToDebitChanged = accountToDebit => this.setState({
    accountToDebit,
    accountToDebitValidationState: validateTextState(accountToDebit, false),
    error: null,
  })

  noteChanged = note => this.setState({
    note,
    noteValidate: this.getNoteValidationState(note),
    error: null,
  })

  checkForm = (transactionDate, transactionAmount, paymentType, accountToDebit, note) => {

    const validDate = validateDateState(transactionDate, this.loanDate),
    validAmount =  this.getAmountValidationState(transactionAmount),
    validPaymentType = this.getPaymentTypeValidationState(paymentType),
    validAccountToDebit = validateTextState(accountToDebit, false),
    validNote = this.getNoteValidationState(note)

    this.setState({
      transactionAmountValidate: validAmount,
      paymentTypeValidate: validPaymentType,
      accountToDebitValidationState: validAccountToDebit,
      noteValidate: validNote,
    })

    return validDate === VALIDATION_TYPE.SUCCESS
      && validAmount === VALIDATION_TYPE.SUCCESS
      && validPaymentType === VALIDATION_TYPE.SUCCESS
      && validAccountToDebit === VALIDATION_TYPE.SUCCESS
      && validNote !== VALIDATION_TYPE.ERROR
  }

  savePayment = () => {

    this.setState({ error: null })
    const { transactionDate, transactionAmount, paymentType, accountToDebit, note } = this.state

    if(!this.checkForm(transactionDate, transactionAmount, paymentType, accountToDebit, note)) {
      this.setState({ error: 'Some fields are incorrect.' })
      return
    }

    const data = { transactionDate, transactionAmount, paymentType, accountToDebit, note },
    { loan: { id: loanId }, saveRepayment } = this.props
    saveRepayment(loanId, data)
  }

  handleDismiss = () => browserHistory.push(`/loans/${ this.props.loan.id }/detail`)

  handleNew = () => {
    this.setState({
      transactionDate: moment().format(DATE_FORMAT_STR),
      transactionAmount: '',
      paymentType: 'CASH',
      accountToDebit: '',
      note: '',

      transactionAmountValidate: VALIDATION_TYPE.NULL,
      paymentTypeValidate: VALIDATION_TYPE.SUCCESS,
      accountToDebitValidationState: VALIDATION_TYPE.NULL,
      noteValidate: VALIDATION_TYPE.NULL,
    })
    this.props.newRepayment()
  }

  renderSuccess = () => (
    <Alert bsStyle="success" onDismiss={ this.handleDismiss }>
      <h3><FontAwesome name='check-circle'/> Repayment successful saved</h3>
      <p>
        Operation ID: { this.props.successText }
      </p>
      <p className="align-right">
        <Button onClick={ this.handleDismiss }>Done!</Button>
        &nbsp; &nbsp;
        <Button bsStyle="success" onClick={ this.handleNew }>New repayment</Button>
      </p>
    </Alert>
  )

  renderSubHeader = principal => {

    const { loadDetailsRunning, loadDetailsFailed, reloadLoanDetails } = this.props,
    currentBalance = this.getCurrentBalance()

    return (
      <table width='100%' className="mv-20">
        <tbody>
        <tr>
          <td>Principal<br/> { formatCurrency(principal) }</td>
          <td width='30%'>
          { loadDetailsFailed
          ? <span>Failed to check balance</span>
          : loadDetailsRunning
            ? <span><FontAwesome name='clock-o'/> Checking balance ..</span>
            : <span>Current Balance <br/>{ formatCurrency(currentBalance) }</span>
          }
          </td>
          <td>
            <span className="reloadSave" onClick={() => reloadLoanDetails()}
              title="Reload balance">
              Reload <FontAwesome name='refresh'/>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    )
  }

  getHelperText = (accountState, accountType) => <span>{ accountState === VALIDATION_TYPE.ERROR
    ? 'Choose an account'
    : <span>Only { accountType } accounts are displayed.{' '}
      <Link to="/settings/accounting">See settings</Link>
    </span>}
  </span>

  renderForm = currencyCode => {

    const todayDate = moment().format(DATE_FORMAT_STR),

    { error: errorProp, running, glAccountsData, loadDetailsRunning, accountType } = this.props,

    { error: errorState, transactionDate, transactionAmount, paymentTypeValidate,
      transactionAmountValidate, paymentType, noteValidate, note, accountToDebit,
      accountToDebitValidationState } = this.state,

    error = errorState ? errorState : errorProp

    return (
      <Form horizontal onSubmit={e => { e.preventDefault(); this.savePayment() }}>

        <FormControlInlineDate controlId="transactionDate"
          label='Transaction date'
          validationState={ validateDateState(transactionDate, this.loanDate) }
          value={ transactionDate }
          onChange={ this.transactionDateChanged }
          min={ this.loanDate }
          max={ todayDate }
          placeholder="Transaction Date"
          disabled={ running }
          helpText={ `Pick a date between ${ this.loanDate } and ${ todayDate }.` }
        />

        <FormControlInlineInput controlId="transactionAmount"
          validationState={ transactionAmountValidate }
          label={`Transaction amount (${ currencyCode })`}
          value={ transactionAmount }
          onChange={ this.transactionAmountChanged }
          placeholder="Transaction amount"
          disabled={ running }
          helpText={`The Amount must be between 1 and ${ this.getCurrentBalance() }`}
        />

        <FormControlInlineSelect
          controlId='paymentType' validationState={ paymentTypeValidate }
          label='Payment type' value={ paymentType }
          onChange={ this.paymentTypeChanged }
          options={[{ value: "CASH", title: "Cash Payment" }]}
          withEmptyOption={ true }
          helpText={ paymentTypeValidate === VALIDATION_TYPE.ERROR ? 'Choose the payment type' : '' }
          disabled={ running }
        />

        <FormControlInlineSelect
          controlId='accountToDebit' validationState={ accountToDebitValidationState }
          label='Account to debit' value={ accountToDebit }
          onChange={ this.accountToDebitChanged }
          options={ glAccountsData }
          withEmptyOption={ true }
          helpText={ this.getHelperText(accountToDebitValidationState, accountType) }
          disabled={ running }
        />

        <FormGroup controlId="note" validationState={ noteValidate }>

          <Col componentClass={ControlLabel} sm={4}>
            Note
          </Col>

          <Col sm={8}>
            <FormControl componentClass="textarea" placeholder="Type here"
            value={ note } disabled={ running }
            onChange={e => this.noteChanged(e.target.value)} />
            <FormControl.Feedback />
            <HelpBlock>Can be empty or must be at least 3 chars</HelpBlock>
          </Col>
        </FormGroup>

        <FormGroup>

          <Col smOffset={4} sm={8}>

            <ProcessesStatus error={ error } running={ running } />

            <ButtonToolbar>
              <Button bsStyle="success"
                onClick={ this.savePayment }
                disabled={ running || loadDetailsRunning || !this.getCurrentBalance() }
                className="w-100p">
                <FontAwesome name='save' /> { running ? "Running.." : "Save"}
              </Button>
            </ButtonToolbar>

          </Col>
        </FormGroup>
      </Form>
    )
  }

  render() {
    const { loan, success } = this.props,
    { id: loanId, bundle } = loan,
    dataBreadCrumbs = [
      { url: '/loans', title: 'Loans' },
      { url: `/loans/${ loanId }/detail`, title: loan.clientName }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText='Repayment' data={ dataBreadCrumbs } />

        <div className="simple-form max-width-700 mx-auto mb-20">

          <h3 className='flex-row-simple items-center text-xl sm:text-2xl'>
            <FontAwesome name='arrow-circle-left' className='pr-10 cursor-pointer'
              onClick={ this.handleDismiss } title='Back' />
            <span className='flex1 pl-10'>Repayments for{' '}
              <strong>{ bundle.name } - { bundle.currencyCode } { formatCurrency(loan.amount) }</strong>
            </span>
          </h3>

          { this.renderSubHeader(loan.amount) }

          { success ? this.renderSuccess() : this.renderForm(bundle.currencyCode) }
        </div>
      </div>
    )
  }
}

RepaymentForm.propTypes = {
  loan: PropTypes.object.isRequired,
}

export default RepaymentForm



// WEBPACK FOOTER //
// ./src/components/Loans/RepaymentForm.js